<!-- Menu Item Details Page - Item Info -->
<template>
    <ion-card v-if="item" class="ion-text-center color-dark">
        <slot />
        <ion-row v-if="backText && !isNative" class="full-width ion-align-items-start">
            <back-button aria-label="back" mode="md" :backText="backText" class="back-btn" />
            <ion-item-divider class="mx-16" />
        </ion-row>
        <h1 v-html="editing ? displayName : item.name" class="mt-8 bold menu-item-title" data-cy="menu-item-title" :class="{ editing: editing }" />
        <ion-row class="full-width d-flex ion-justify-content-center">
            <div class="img-container d-flex ion-justify-content-center">
                <ion-img :src="isMobile ? item.mobileImg : item.cdnImg" :class="imageClass" :alt="displayName" data-cy="menu-item-image" />
                <div class="banner" v-if="item.itemTextBanner">{{ item.itemTextBanner }}</div>
            </div>
        </ion-row>
        <ion-card-content class="interstate-bold item-description" v-html="item.description" data-cy="menu-item-description" />
    </ion-card>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue';
import { IonCard, IonImg, IonCardContent, IonItemDivider, IonRow } from '@ionic/vue';
import { MenuItem } from '@/models/menuModels';
import { useStore } from 'vuex';
import updateMeta from '@/services/pageService';
import backButton from '@/components/backButton.vue';

export default defineComponent({
    props: {
        item: { type: Object as PropType<MenuItem>, required: true },
        altName: String,
        editing: Boolean,
        backText: String,
    },
    components: { IonCard, IonImg, IonCardContent, IonItemDivider, IonRow, backButton },
    setup(props) {
        const store = useStore();
        const displayName = computed(() => props.altName ?? props.item.name);
        updateMeta({ title: displayName.value, description: props.item?.description, image: props.item?.cdnImg });
        const isNative = computed(() => store.getters.isNative);

        const isMobile = computed(() => store.getters.isMobile);
        const imageClass = computed(() => {
            return {
                'image-ratio-mobile': isMobile.value,
                'image-ratio-desktop': !isMobile.value,
            };
        });

        return { displayName, isNative, imageClass, isMobile };
    },
});
</script>

<style scoped>
h1 {
    font-size: 2.5em;
    padding-inline: 25px;
}

.item-description {
    font-size: 1.2em;
}

@media screen and (max-width: 960px) {
    h1 {
        padding-inline: 8px;
        margin: 4px 0;
    }

    ion-card {
        margin-top: 0;
    }

    .img-container {
        display: block;
        overflow: hidden;
    }

    ion-img {
        width: 100%;
        object-fit: cover;
        max-width: unset;
    }
}

.editing {
    font-size: 2em;
}

.menu-item-title {
    font-family: interstate;
    font-weight: bold;
}

.img-container {
    position: relative;
    width: 100%;
}

.banner {
    background: var(--ion-color-primary);
    position: absolute;
    width: 100%;
    bottom: 0px;
    padding: 10px;
    color: white;
    font-weight: bold;
}

.image-ratio-desktop {
    aspect-ratio: 1/1;
    object-fit: cover;
    width: 100%;
    object-position: center center;
}

.image-ratio-mobile {
    aspect-ratio: 3/2;
    object-fit: cover;
    object-position: center center;
}
</style>
